import { FileText } from 'lucide-react';
import { DocPage } from '@/components/investor';
import { onePagerSections, onePagerStatus, onePagerSummary, onePagerTop } from '@/content/onePager';
import { SITE } from '@/lib/site';

/** Direct-access investor page — deliberately absent from the navigation. Mirrors docs/investors/fnk/one-pager.md. */
export function OnePagerPage() {
  return (
    <DocPage
      badgeIcon={FileText}
      badge="Investor One-Pager"
      title="Fnk — the AI stack, the Harness and the inference underneath enterprise AI."
      status={onePagerStatus}
      summary={onePagerSummary}
      top={onePagerTop}
      sections={onePagerSections}
      contactEmail={SITE.investors}
      deckPath="/pitch"
      footer="Confidential. Zero paying customers as of this page; every commercial figure is a management scenario."
    />
  );
}
